import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiFeaturemanagementIsstripepaymentenabledQueryResponse,
  GetApiFeaturemanagementIsstripepaymentenabled401,
  GetApiFeaturemanagementIsstripepaymentenabled403,
} from "../../../types/GetApiFeaturemanagementIsstripepaymentenabled";

export function getGetApiFeaturemanagementIsstripepaymentenabledUrl() {
  return `/api/FeatureManagement/IsStripePaymentEnabled` as const;
}

/**
 * {@link /api/FeatureManagement/IsStripePaymentEnabled}
 */
export async function getApiFeaturemanagementIsstripepaymentenabled(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiFeaturemanagementIsstripepaymentenabledQueryResponse,
    ResponseErrorConfig<
      | GetApiFeaturemanagementIsstripepaymentenabled401
      | GetApiFeaturemanagementIsstripepaymentenabled403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiFeaturemanagementIsstripepaymentenabledUrl().toString(),
    ...requestConfig,
  });
  return res;
}
